import '../httpservices/core/ajax.httpservice.core';

class UnityHttpService {

    IsAvailable() {
        return $.get('api/Unity/IsAvailable?enableOutageResponse=true');
    }
}

export const UnityHttpSvc = new UnityHttpService();